import { FormattedMessage } from "react-intl";

import { messages } from "./messages";
import { DepositUnavailableProps } from "./types";
import { ReactComponent as WarningIcon } from "assets/images/icons/warning.svg";

export const DepositUnavailable: React.FC<DepositUnavailableProps> = () => {
  return (
    <div className="flex max-w-2xl flex-col gap-6">
      <div className="flex flex-col">
        <h1 className="mb-4 font-['Tomato_Grotesk'] text-3xl font-medium">
          <FormattedMessage {...messages.title} />
        </h1>
        <div
          className={
            "flex items-center text-xs font-semibold text-[--milkylb-color-neutral-400]"
          }
        >
          <WarningIcon className="shrink-0" />{" "}
          <p className="ml-2">
            <FormattedMessage {...messages.alertSign} />
          </p>
        </div>
      </div>
    </div>
  );
};
